<template>
  <v-dialog v-model="dialog" max-width="700" persistent scrollable>
    <v-card>
      <v-card-title class="teal darken-1 white--text">
        <v-icon left dark>mdi-email-send</v-icon>
        Notificar Suscriptores
      </v-card-title>
      <v-card-subtitle class="pt-3 pb-0">
        <strong>Post:</strong> {{ postTitle }}<br>
        <strong>Categoría:</strong> {{ categoryName }}
      </v-card-subtitle>

      <v-card-text class="pt-3">
        <!-- Loading -->
        <div v-if="loading" class="text-center pa-4">
          <v-progress-circular indeterminate color="teal"></v-progress-circular>
          <p class="mt-2 grey--text">Cargando suscriptores...</p>
        </div>

        <!-- Sin suscriptores -->
        <v-alert v-else-if="!subscribers.length" type="info" text dense>
          No hay suscriptores activos en esta categoría.
        </v-alert>

        <!-- Tabla con checkboxes -->
        <div v-else>
          <v-checkbox v-model="selectAll" label="Seleccionar todos" hide-details
            class="mb-2" @change="toggleAll"></v-checkbox>
          <v-divider class="mb-2"></v-divider>

          <v-simple-table dense fixed-header max-height="350px">
            <template v-slot:default>
              <thead>
                <tr>
                  <th width="50"></th>
                  <th>Usuario</th>
                  <th>Email</th>
                  <th>Suscrito desde</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="sub in subscribers" :key="sub.id">
                  <td>
                    <v-checkbox v-model="selectedIds" :value="sub.id" hide-details
                      dense class="mt-0 pt-0"></v-checkbox>
                  </td>
                  <td>{{ sub.user ? sub.user.name : '—' }}</td>
                  <td>{{ sub.email }}</td>
                  <td>{{ formatDate(sub.created_at) }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <p class="caption grey--text mt-2">
            {{ selectedIds.length }} de {{ subscribers.length }} seleccionados
          </p>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="cerrar">Cancelar</v-btn>
        <v-btn color="teal" dark :loading="sending" :disabled="!selectedIds.length"
          @click="enviar">
          <v-icon left small>mdi-send</v-icon>
          Enviar ({{ selectedIds.length }})
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import forumService from '@/services/forumService.js';

export default {
  name: 'ForumNotifyDialog',
  data() {
    return {
      dialog: false,
      loading: false,
      sending: false,
      postId: null,
      postTitle: '',
      categoryId: null,
      categoryName: '',
      subscribers: [],
      selectedIds: [],
      selectAll: true,
    };
  },
  methods: {
    open(post) {
      this.postId = post.id;
      this.postTitle = post.title;
      this.categoryId = post.category_id || (post.category ? post.category.id : null);
      this.categoryName = post.category ? post.category.name : '';
      this.subscribers = [];
      this.selectedIds = [];
      this.selectAll = true;
      this.dialog = true;
      this.cargarSuscriptores();
    },
    cargarSuscriptores() {
      if (!this.categoryId) return;
      this.loading = true;
      forumService.suscriptoresPorCategoria(this.categoryId)
        .then(res => {
          this.subscribers = res.data || [];
          // Seleccionar todos por defecto
          this.selectedIds = this.subscribers.map(s => s.id);
          this.selectAll = true;
        })
        .catch(() => {
          this.subscribers = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    toggleAll(val) {
      if (val) {
        this.selectedIds = this.subscribers.map(s => s.id);
      } else {
        this.selectedIds = [];
      }
    },
    enviar() {
      if (!this.selectedIds.length) return;
      this.sending = true;
      forumService.notificarSuscriptores(this.postId, { subscription_ids: this.selectedIds })
        .then(res => {
          this.$emit('notificado', res.data);
          this.cerrar();
        })
        .catch(() => {
          this.$emit('error', 'Error al enviar notificaciones');
        })
        .finally(() => {
          this.sending = false;
        });
    },
    cerrar() {
      this.dialog = false;
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      return d.toLocaleDateString('es', { day: '2-digit', month: 'short', year: 'numeric' });
    }
  },
  watch: {
    selectedIds(val) {
      this.selectAll = val.length === this.subscribers.length && this.subscribers.length > 0;
    }
  }
};
</script>
